import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43845652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-queue-modal-choose-users" }
const _hoisted_2 = { class: "edit-queue-modal-choose-users__wrap-title" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { style: {"width":"52.2rem","overflow":"hidden"} }
const _hoisted_5 = {
  class: "wrap-title",
  style: {"justify-content":"start","align-items":"center"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ФИО сотрудника", -1))
const _hoisted_7 = { class: "wrap-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Добавление"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" задач ")
], -1))
const _hoisted_9 = { class: "wrap-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Редактирование "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("чужих задач")
], -1))
const _hoisted_11 = { class: "wrap-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Просмотр чужих"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" задач ")
], -1))
const _hoisted_13 = { class: "wrap-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Итоговая оценка"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("времени")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal_border" }, null, -1))
const _hoisted_16 = { class: "deleted-users" }
const _hoisted_17 = { class: "delete-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "Авторы тикетов, удаленные из очереди", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"18rem"} }, " Список только тех удаленных Авторов чьи тикеты еще есть в очереди ", -1))

import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmSelectBadge,
  TirPmIconView,
  TirCheckbox,
} from "tir-components";
import { computed, inject, PropType, ref, watch } from "vue";
import { EmployeeAccessModel, EmployeeModel } from "../../models";
import { EmployeeQueueAccessEnum } from "../../enums";
import { AddEmployeeDropdown } from "./";
import TirPmSearchInput from "tir-pm-search-input/src/TirPmSearchInput.vue";
import { TirPmTable, TirPmTableTh, TirPmTableTr, TirPmTableTd } from "tir-pm-table";
import {
  Bars3BottomLeftIcon,
  BarsArrowDownIcon,
  BarsArrowUpIcon,
  InformationCircleIcon,
  PlusIcon,
  ScissorsIcon,
} from "tir-style-system/icons/outline";
import { UserItem } from "../";

import TirPmSystemMessage from "tir-pm-system-message/src/tir-pm-system-message.vue";
import { TaskParametersLeave } from "@/components/task-parameters-form/components";
import { NeutralInformation } from "tir-style-system/icons/solid";
import { TirPmTooltipElement, TirPmTooltipElementPlacementEnum } from "tir-pm-tooltip-element";
import { AccessAdapterService } from "@/components/task-forms/components/task-detail/adapter/AccessAdapterService";
import { useRoute, useRouter } from "vue-router";
import { QueueTasksModel } from "@/components/sidebar/models";
import { CurrentUser } from "tir-pm-user-core";
/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-queue-modal-choose-users',
  props: {
  /**Заголовок */
  title: { type: String },
  /**Список добавленных к очереди пользователей */
  queueUsers: { type: Array as PropType<EmployeeAccessModel[]> },
  queueDeletedUsers: { type: Array as PropType<EmployeeModel[]> },
  /**Список пользователей */
  allUsers: { type: Array as PropType<EmployeeModel[]> },
  /**Главный список (отсутствуют кнопки _buttons) */
  access: { type: Number as PropType<EmployeeQueueAccessEnum> },
  /**Можно ли добавлять всех пользователей */
  allowAddEveryone: { type: Boolean },

  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
},
  emits: ["addEveryone", "removeEveryone", "selectUser", "onChange", "onSave", "onClose", "removeUser"],
  setup(__props, { emit }) {

const props = __props;


/**События */

const columnTableSetting = ref([
  "minmax(12.5rem, 1fr)",
  // 'minmax(5.563rem, 5.563rem)',
  "minmax(6.25rem, 6.25rem)",
  "minmax(7.75rem, 7.75rem)",
  "minmax(7.75rem, 7.75rem)",
  "minmax(7.7rem, 7.7rem)",
]);

/**Главный список пользователей */
const main = computed(() => props.access == undefined);

/**Список id уже добавленных пользователей */
const addedUsersIds = computed(() => props.queueUsers.map((u) => u.Id));
/**Отображаемый список пользователей */
const options = computed(
  () => props.allUsers?.filter((u) => !addedUsersIds.value.includes(u.Id)) || [],
);
/**Окно для подтверждения закрытия настроек параметров */
const $taskParametersLeave = ref<InstanceType<typeof TaskParametersLeave>>();
/**Добавить всех */
const addEveryone = () => emit("addEveryone", props.access);
/**Удалить всех */
const removeEveryone = () => emit("removeEveryone", props.access);
/**Выбор пользователя */
const selectUser = (userId: number) => emit("selectUser", userId, props.access);
/**Удаление пользователя */
const removeUser = (userId: number) => emit("removeUser", userId, props.access);
const isChanged = ref(false);
const colCheckBox = ref([false, false, false, false, false]);
const colUnselect = ref([false, false, false, false, false]);
const userNameSearch = ref("");

/**сохранить данные */
function changeData() {
  isChanged.value = false;
  emit("onSave");
}

function checkCheckboxesStateCol(col: number) {
  let sum = 0;
  props.queueUsers.forEach((user) => {
    sum = user.Accesses[col] ? sum + 1 : sum;
  });
  if (sum === 0) {
    colUnselect.value[col] = false;
    colCheckBox.value[col] = false;
  } else if (sum === props.queueUsers.length) {
    colUnselect.value[col] = false;
    colCheckBox.value[col] = true;
  } else {
    colUnselect.value[col] = true;
    colCheckBox.value[col] = true;
  }
}

watch(
  () => props.queueUsers?.length,
  () => {
    for (let index = 0; index < 4; index++) {
      checkCheckboxesStateCol(index);
    }
  },
);

function onChangeAccessQueue(value: EmployeeAccessModel, col: number) {
  isChanged.value = true;
  emit("onChange", true);

  // Чекбокс включен у сотрудника
  if (value.Accesses[col]) {
    switch (col) {
      case 1:
      case 3:
        value.Accesses[2] = true;
        break;
    }
  } else {
    switch (col) {
      case 2:
        value.Accesses[1] = false;
        value.Accesses[3] = false;
        break;
    }
  }

  for (let index = 0; index < 4; index++) {
    checkCheckboxesStateCol(index);
  }
}

function setStartPositions() {
  for (let i = 0; i < 4; i++) {
    let sum = 0;
    props.queueUsers.forEach((user) => {
      sum = user.Accesses[i] ? sum + 1 : sum;
    });
    colCheckBox.value[i] = sum == 4;
    colUnselect.value[i] = sum == 4;
  }
}

/**Открыть окно с подтверждением выхода из настройки */
const openLeaveConfirmation = (callback?: Function) => {
  $taskParametersLeave.value?.toggle(true, callback);
};

function update(user: EmployeeAccessModel) {
  isChanged.value == true;
  emit("onChange", true);
}
const router = useRouter();
const adapter = new AccessAdapterService();
function addPerformer() {
  emit("onClose");
  router.push({
    name: "namespace-team",
    params: {
      projectId: route.params.projectId,
      namespaceId: props.queue.NamespaceId,
      queueId: props.queue.Id,
    },
  });
}
function changeColumnData(value: number) {
  props.queueUsers.forEach((user) => {
    user.Accesses[value] = colCheckBox.value[value];
    if (colCheckBox.value[value]) {
      switch (value) {
        case 1:
        case 3:
          user.Accesses[2] = true;
          break;
      }
    } else {
      switch (value) {
        case 2:
          user.Accesses[1] = false;
          user.Accesses[3] = false;
          break;
      }
    }
  });
  for (let index = 0; index < 4; index++) {
    checkCheckboxesStateCol(index);
  }
  isChanged.value = true;
  emit("onChange", true);
}
const route = useRoute();
async function isCanAddPerformer() {
  let resp = true;
  let u = CurrentUser;
  await adapter.isNamespaceAdmin({ NamespaceId: props.queue.NamespaceId, UserId: u.Id });
  await adapter.isProjectAdmin({ ProjectId: Number(route.params.projectId), UserId: u.Id });
  resp = adapter.IsProjectAdmin || adapter.IsNamespaceAdmin || u.Roles.includes(2);
  return resp;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["edit-queue-modal-choose-users_title", { main: main.value }]),
        textContent: _toDisplayString(__props.title)
      }, null, 10, _hoisted_3),
      _createVNode(TirPmSearchInput, {
        class: "ml-auto",
        "is-small": true,
        modelValue: userNameSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userNameSearch).value = $event)),
        label: "Имя пользователя",
        placeholder: "Имя пользователя"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(TirPmButton), {
        onClick: changeData,
        class: "tasks-kanban__header__add ml-2",
        variant: 
          !isChanged.value ? _unref(TirPmButtonVariantEnum).SecondaryState : _unref(TirPmButtonVariantEnum).PrimaryState
        ,
        size: _unref(TirPmButtonSizeEnum).Small,
        "is-disabled": !isChanged.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Применить изменения ")
        ]),
        _: 1
      }, 8, ["variant", "size", "is-disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(TirPmTable), {
        columns: columnTableSetting.value,
        isBordered: false,
        style: {"overflow":"auto"}
      }, {
        emptyDataSlot: _withCtx(() => [
          (!(__props.queueUsers?.length > 0))
            ? (_openBlock(), _createBlock(TirPmSystemMessage, {
                key: 0,
                style: {"width":"100%","margin":"5rem 0rem"}
              }, {
                topDescImage: _withCtx(() => []),
                mainTitleSlot: _withCtx(() => [
                  _createTextVNode("Добавьте сотрудников в команду рабочей области")
                ]),
                actionsSlot: _withCtx(() => [
                  (isCanAddPerformer())
                    ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                        key: 0,
                        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                        size: _unref(TirPmButtonSizeEnum).Middle,
                        onClick: addPerformer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить ")
                        ]),
                        _: 1
                      }, 8, ["variant", "size"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        tableHead: _withCtx(() => [
          _createVNode(_unref(TirPmTableTh), { isLeftBorder: false }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_unref(Bars3BottomLeftIcon), { style: {"width":"1rem","margin-left":"1rem"} })
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(TirPmTableTh), { isLeftBorder: true }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_unref(TirCheckbox), {
                  isUnselect: colUnselect.value[0],
                  modelValue: colCheckBox.value[0],
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((colCheckBox.value[0]) = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (changeColumnData(0)))
                  ]
                }, null, 8, ["isUnselect", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(TirPmTableTh), { isLeftBorder: true }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_unref(TirCheckbox), {
                  isUnselect: colUnselect.value[1],
                  modelValue: colCheckBox.value[1],
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((colCheckBox.value[1]) = $event)),
                    _cache[4] || (_cache[4] = ($event: any) => (changeColumnData(1)))
                  ]
                }, null, 8, ["isUnselect", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(TirPmTableTh), { isLeftBorder: true }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_unref(TirCheckbox), {
                  isUnselect: colUnselect.value[2],
                  modelValue: colCheckBox.value[2],
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((colCheckBox.value[2]) = $event)),
                    _cache[6] || (_cache[6] = ($event: any) => (changeColumnData(2)))
                  ]
                }, null, 8, ["isUnselect", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(TirPmTableTh), { isLeftBorder: true }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(TirCheckbox), {
                  isUnselect: colUnselect.value[3],
                  modelValue: colCheckBox.value[3],
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => ((colCheckBox.value[3]) = $event)),
                    _cache[8] || (_cache[8] = ($event: any) => (changeColumnData(3)))
                  ]
                }, null, 8, ["isUnselect", "modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        tableBody: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queueUsers, (user, idx) => {
            return (_openBlock(), _createBlock(_unref(TirPmTableTr), {
              columns: columnTableSetting.value,
              key: idx
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TirPmTableTd), { style: {"overflow":"visible !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UserItem), { user: user }, null, 8, ["user"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(TirPmTableTd), { style: {"overflow":"visible !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirCheckbox), {
                      class: "ml-auto",
                      modelValue: user.Accesses[0],
                      "onUpdate:modelValue": [($event: any) => ((user.Accesses[0]) = $event), ($event: any) => (onChangeAccessQueue(user, 0))]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(TirPmTableTd), { style: {"overflow":"visible !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirCheckbox), {
                      class: "ml-auto",
                      modelValue: user.Accesses[1],
                      "onUpdate:modelValue": [($event: any) => ((user.Accesses[1]) = $event), ($event: any) => (onChangeAccessQueue(user, 1))]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(TirPmTableTd), { style: {"overflow":"visible !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirCheckbox), {
                      class: "ml-auto",
                      modelValue: user.Accesses[2],
                      "onUpdate:modelValue": [($event: any) => ((user.Accesses[2]) = $event), ($event: any) => (onChangeAccessQueue(user, 2))]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(TirPmTableTd), { style: {"overflow":"visible !important"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirCheckbox), {
                      class: "ml-auto",
                      modelValue: user.Accesses[3],
                      "onUpdate:modelValue": [($event: any) => ((user.Accesses[3]) = $event), ($event: any) => (onChangeAccessQueue(user, 3))]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["columns"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns"])
    ]),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_unref(TirPmTooltipElement), {
          class: "tooltip-element",
          position: _unref(TirPmTooltipElementPlacementEnum).Top
        }, {
          content: _withCtx(() => [
            _hoisted_19
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(NeutralInformation))
          ]),
          _: 1
        }, 8, ["position"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queueDeletedUsers, (delUser, idx) => {
        return (_openBlock(), _createBlock(_unref(UserItem), {
          class: "deleted-user",
          user: delUser,
          queue: __props.queue,
          key: idx
        }, null, 8, ["user", "queue"]))
      }), 128))
    ])
  ]))
}
}

})